import React from "react";
import {
  FaDice,
  FaGamepad,
  FaCoins,
  FaUserPlus,
  FaMobileAlt,
  FaUserShield,
} from "react-icons/fa";

function KeyFeaturesLottery() {
  const features = [
    {
      title: "Algorithmic Randomness",
      desc: "Purely algorithmic results ensure winners represent true transparency, eliminating human intervention.",
      icon: <FaDice />,
    },
    {
      title: "Multiple Game Modes",
      desc: "Offer various fixed-odds and pool-based lottery games to attract different user preferences and strategies.",
      icon: <FaGamepad />,
    },
    {
      title: "Staking & Rewards",
      desc: "Allow users to stake tokens to participate in community pools, incentivizing long-term token retention.",
      icon: <FaCoins />,
    },
    {
      title: "Referral Systems",
      desc: "Encourage community growth by reward systems, boosting total user participation and network effects.",
      icon: <FaUserPlus />,
    },
    {
      title: "Premium UI/UX",
      desc: "Modern, responsive interface makes it easy for players to join pools and track odds across all devices.",
      icon: <FaMobileAlt />,
    },
    {
      title: "Audited Security",
      desc: "Battle-tested smart contracts ensure platform integrity and absolute player protection at all times.",
      icon: <FaUserShield />,
    },
  ];

  return (
    <div
      className="services-area pt-120 pb-120"
      style={{ background: "#ffffff" }}
    >
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-lg-8 offset-lg-2">
            <h4 className="sub-title text-primary fw-bold mb-2">
              Platform Excellence
            </h4>
            <h2
              className="title fw-extrabold"
              style={{ fontWeight: "bold" }}
              // style={{ fontSize: "40px", letterSpacing: "-1px" }}
            >
              Key Features of Our DeFi Lottery Platform
            </h2>
            <p className="mt-3 text-muted fs-5">
              We engineer transparent and fair betting environments utilizing
              robust smart contracts.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {features.map((feature, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="feature-card p-5 h-100 text-center"
                style={{
                  borderRadius: "32px",
                  background: "#f8fdff",
                  border: "1px solid #eef7ff",
                  transition: "all 0.4s ease",
                  cursor: "default",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.background = "#ffffff";
                  e.currentTarget.style.boxShadow =
                    "0 20px 50px rgba(0, 188, 212, 0.1)";
                  e.currentTarget.style.borderColor = "#00bcd420";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.background = "#f8fdff";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#eef7ff";
                }}
              >
                <div
                  className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                  style={{
                    width: "75px",
                    height: "75px",
                    fontSize: "30px",
                    backgroundColor: "#ffffff",
                    color: feature.color,
                    borderRadius: "22px",
                    boxShadow: "0 10px 20px rgba(0,0,0,0.03)",
                  }}
                >
                  {feature.icon}
                </div>

                <h5 className="fw-bold mb-3" style={{ fontSize: "20px" }}>
                  {feature.title}
                </h5>

                <p
                  style={{
                    fontSize: "15px",
                    color: "#6c757d",
                    lineHeight: "1.7",
                    marginBottom: 0,
                  }}
                >
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default KeyFeaturesLottery;
